export default __webpack_public_path__ + "static/media/sUSD.23127f22.webp";